export default {
    methods: {
        /**
         * @description: 获取柱状图的series数据
         * @author: 孙小梅
         * @param {*}
         */
        getBarSeriesObj(sObj) {
            let obj = {}
            if (sObj.name.includes('率')) {
                obj = {
                    name: sObj.name,
                    type: 'line',
                    data: sObj.values,
                    yAxisIndex: 1,
                    smooth: 0.5,
                    symbol: 'circle',
                    symbolSize: 10,  // 圆点大小
                    itemStyle: {
                        normal: {
                            lineStyle: {
                                width: 3   // 线条粗细
                            }
                        }
                    },
                    tooltip: {
                        valueFormatter: function (value) {
                            return value + ' %';
                        }
                    },
                };
            } else {
                obj = {
                    name: sObj.name,
                    type: 'bar',
                    barWidth: "15",
                    itemStyle: {
                        normal: {
                            borderRadius: [8, 8, 8, 8]
                        }
                    },
                    tooltip: {
                        valueFormatter: function (value) {
                            return value + ' 万元';
                        }
                    },
                    data: sObj.values
                }
            }
            return obj;
        },
        /**
         * @description: 圆角堆叠柱状图series数据
         * @author: 孙小梅
         * @param {*}
         */
        getRoundedStackBarSeriesObj(sObj) {
            // {
            //               name: '已开票未回款',
            //               type: 'bar',
            //               stack: '总量',
            //               itemStyle:{
            //                 normal: {
            //                   barBorderRadius:  [8, 8, 8, 8],
            //                   color: '#B6A2DE',
            //                 }
            //               },
            //               data: [220, 182, 191, 234, 290, 330, 310]
            //             }
            let obj = {
                name: sObj.name,
                type: 'bar',
                stack: '总量',
                barWidth: "15",
                itemStyle: {
                    normal: {
                        borderRadius: [3, 3, 3, 3]
                    }
                },
                tooltip: {
                    valueFormatter: function (value) {
                        return value + ' 万元';
                    }
                },
                data: sObj.values
            }
            return obj;
        },
        /**
         * @description: 获取折线图的series数据
         * @author: 孙小梅
         * @param {*}
         */
        getLineSeriesObj(sObj) {
            let obj = {
                name: sObj.name,
                type: 'line',
                showSymbol: false,
                symbol: 'circle',
                symbolSize: 10,
                stack: 'Total',
                data: sObj.values,
                tooltip: {
                    valueFormatter: function (value) {
                        return value + ' 万元';
                    }
                },
            };
            return obj;
        }
    }
}
